<template>
  <!-- ANSKNI-108: minimal chrome for the external client (Bolag B). Deliberately
       carries no admin navigation — the only way around is log out. -->
  <div class="min-h-screen bg-gray-50">
    <header
      class="flex items-center justify-between border-b border-gray-200 bg-white px-4 py-3 sm:px-6"
    >
      <div class="flex items-center gap-3 min-w-0">
        <span class="text-lg font-semibold text-gray-900 truncate"
          >Kandidatpresentation</span
        >
      </div>
      <button
        type="button"
        class="rounded-lg border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-100"
        @click="logout"
      >
        Logga ut
      </button>
    </header>

    <main class="mx-auto w-full max-w-5xl px-4 py-6 sm:px-6">
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const store = useStore();
const router = useRouter();

const logout = async () => {
  await store.dispatch("logout");
  router.push("/login");
};
</script>
